import {
  Box,
  Button,
  Stack,
  Typography,
  useResponsive,
  useTheme
} from '@rabex-kit/rabex-ui';
import NotFoundEarthLight from '../../static/images/svg/NotFoundEarthLight.svg?react';
import NotFoundEarthDark from '../../static/images/svg/NotFoundEarthDark.svg?react';
import { DASHBOARD } from '../routes';

export default function NotFound() {
  const { matches } = useResponsive();
  const { palette } = useTheme();

  return (
    <Stack height="100vh">
      <Stack m="auto" alignItems="center" gap={3}>
        {palette.mode === 'light' ? (
          <NotFoundEarthLight
            style={{ width: matches({ xs: 400, md: 506 }) }}
          />
        ) : (
          <NotFoundEarthDark style={{ width: matches({ xs: 400, md: 506 }) }} />
        )}
        <Typography variant="h6" weight="bold">
          صفحه مورد نظر پیدا نشد!
        </Typography>
        <Typography variant="body1" color={palette.textColor[400]}>
          آدرس این صفحه اشتباه است و یا دیگر وجود ندارد.
        </Typography>
        <Box marginTop={5}>
          <a href={DASHBOARD} style={{ textDecoration: 'none' }}>
            <Button>بازگشت به خانه</Button>
          </a>
        </Box>
      </Stack>
    </Stack>
  );
}
